import { render, staticRenderFns } from "./TestItemWordselect.vue?vue&type=template&id=6aa9acfc&scoped=true&"
import script from "./TestItemWordselect.vue?vue&type=script&lang=js&"
export * from "./TestItemWordselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9acfc",
  null
  
)

export default component.exports